"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bwaRedirectInfoWidgetRenderHandler = _interopRequireDefault(require("./bwa-redirect-info-widget-render-handler"));
var BwaRedirectInfoWidget = exports["default"] = /*#__PURE__*/function () {
  function BwaRedirectInfoWidget(config) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, BwaRedirectInfoWidget);
    this.config = config;
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(BwaRedirectInfoWidget, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.renderHandler = new _bwaRedirectInfoWidgetRenderHandler["default"](this.config);
              _context.next = 3;
              return this.renderHandler.executeHandler();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }]);
}();
//# sourceMappingURL=bwa-redirect-info-widget.js.map
